import React from 'react';
import {Container} from "react-bootstrap";
import {Helmet} from "react-helmet";

export const TermsAndConditions: React.FC = () => (
    <>
        <Helmet>
            <title>Terms and Condition</title>
            <meta
                name="description"
                content="Terms and conditions of our service."
            />
        </Helmet>

        <Container>
            <h1>Terms and Conditions</h1>
            <p><strong>Effective Date:</strong> April 17, 2025</p>

            <h2>1. Acceptance of Terms</h2>
            <p>
                By accessing or using Litlap (“we,” “us,” “our”) at <code>https://www.litlap.com</code>,
                you agree to be bound by these Terms and Conditions and our Privacy Policy.
                If you do not agree, please do not use the Service.
            </p>

            <h2>2. Description of Service</h2>
            <p>
                Litlap provides a collection of mini‑apps and mini‑games accessible via web browser,
                including but not limited to tic‑tac‑toe, word counter, and IP lookup tools.
                We also display advertising via Google AdSense and offer paid subscriptions
                for premium features via Stripe.
            </p>

            <h2>3. Subscriptions & Payments</h2>
            <ul>
                <li>Subscriptions are billed monthly through Stripe.</li>
                <li>You authorize us to charge your payment method for all fees incurred.</li>
                <li>All fees are non‑refundable except as required by law or our refund policy (if any).</li>
                <li>You may cancel at any time; cancellation takes effect at the end of the current billing period.</li>
            </ul>

            <h2>4. Advertisements</h2>
            <p>
                We display third‑party ads (e.g. Google AdSense) on certain pages. We have no control
                over ad content, and any issues with ads should be directed to the ad provider.
            </p>

            <h2>5. User Conduct</h2>
            <p>
                You agree not to misuse the Service or interfere with its operation. You will not attempt
                to reverse engineer, hack, or otherwise compromise our systems.
            </p>

            <h2>6. Intellectual Property</h2>
            <p>
                All content, logos, and code on Litlap are our property or licensed to us.
                You may not copy, reproduce, or distribute without our express permission.
            </p>

            <h2>7. Disclaimers & Limitation of Liability</h2>
            <p>
                The Service is provided “as is” without warranty of any kind. To the fullest extent permitted
                by law, Litlap and its affiliates disclaim all warranties, and will not be liable for any
                damages arising from your use of the Service.
            </p>

            <h2>8. Governing Law</h2>
            <p>
                These Terms are governed by the laws of United States. Any dispute must be brought
                in the state or federal courts located in Charlotte, North Carolina.
            </p>

            <h2>9. Changes to Terms</h2>
            <p>
                We may update these Terms at any time. We’ll post the updated date at the top, and your
                continued use constitutes acceptance.
            </p>

            <h2>10. Contact Us</h2>
            <p>
                For support or questions, email <a href="mailto:support@litlap.com">support@litlap.com</a>.
            </p>
        </Container>
    </>
);